import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { cyberpunkColors } from './theme/cyberpunkTheme';

const Spot = ({ rate, od_rate }) => {
  const discount = od_rate ? Math.round(100 - (rate / od_rate) * 100) : 0;

  const getDiscountColor = (d) => {
    if (d >= 70) return cyberpunkColors.neonGreen;
    if (d >= 50) return cyberpunkColors.neonCyan;
    return cyberpunkColors.neonMagenta;
  };

  return (
    <Card
      sx={{
        background: 'linear-gradient(145deg, #1a1a24, #0d0d14)',
        border: '1px solid rgba(255, 0, 255, 0.3)',
        borderRadius: 2,
        transition: 'all 0.3s ease',
        height: '100%',
        '&:hover': {
          borderColor: cyberpunkColors.neonMagenta,
          boxShadow: '0 0 25px rgba(255, 0, 255, 0.2)',
        },
      }}
    >
      <CardContent>
        <Typography
          sx={{
            fontSize: 11,
            fontFamily: '"Orbitron", sans-serif',
            color: cyberpunkColors.textSecondary,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            mb: 1,
          }}
        >
          Spot Rate
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 1 }}>
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Orbitron", sans-serif',
              fontWeight: 700,
              color: cyberpunkColors.neonMagenta,
              textShadow: '0 0 10px rgba(255, 0, 255, 0.5)',
            }}
          >
            ${rate}
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              color: cyberpunkColors.textSecondary,
              fontFamily: '"Rajdhani", sans-serif',
            }}
          >
            /hr
          </Typography>
        </Box>
        {discount > 0 && (
          <Chip
            label={`${discount}% savings`}
            size="small"
            sx={{
              backgroundColor: `${getDiscountColor(discount)}20`,
              color: getDiscountColor(discount),
              border: `1px solid ${getDiscountColor(discount)}`,
              fontFamily: '"Orbitron", sans-serif',
              fontSize: 11,
              fontWeight: 600,
            }}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default Spot;
